(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bane-mobile-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const saved = new Map();
  const roots = new WeakSet();
  let timer;
  const remember = (node) => {
    if (!saved.has(node)) saved.set(node, {style: node.getAttribute('style'), label: node.getAttribute('aria-label')});
  };
  const set = (node, styles) => {
    remember(node);
    Object.entries(styles).forEach(([name, value]) => node.style.setProperty(name, value, 'important'));
  };
  const compact = (button, floating, label) => {
    if (button.dataset.baneCompactWishlist) return;
    button.dataset.baneCompactWishlist = 'true';
    remember(button);
    if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', label);
    set(floating, {width:'44px',height:'44px','min-width':'44px','min-height':'44px','max-width':'44px','max-height':'44px',padding:'0',transform:'none'});
    set(button, {width:'44px',height:'44px','min-width':'44px','min-height':'44px','max-width':'44px','max-height':'44px',padding:'0','border-radius':'50%','font-size':'0',display:'inline-flex','align-items':'center','justify-content':'center',background:'#24272a',color:'#f1e1c2',border:'1px solid #ad9673','box-shadow':'0 2px 8px #0003',overflow:'hidden'});
    [...button.children].forEach(child => set(child, {display:'none'}));
    const icon = document.createElement('span');
    icon.dataset.baneWishlistIcon = 'true';
    icon.setAttribute('aria-hidden','true');
    icon.style.cssText='display:block!important;width:21px!important;height:21px!important;pointer-events:none!important;line-height:0!important';
    icon.innerHTML='<svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
    button.append(icon);
  };
  const inspect = (root) => {
    if (!roots.has(root)) { roots.add(root); new MutationObserver(schedule).observe(root,{childList:true,subtree:true}); }
    if (!mobile.matches) return;
    root.querySelectorAll('button,a,[role="button"]').forEach(button => {
      if (button.dataset.baneCompactWishlist) return;
      const label=(button.getAttribute('aria-label')||button.textContent||'').trim();
      if (label.length>55 || !/^(?:[♡♥\s\d]*)?(Wunschliste|Wishlist|Liste de souhaits)(?:[\s\d()]*)$/i.test(label)) return;
      let floating=button;
      for(let depth=0;floating&&depth<7;depth++,floating=floating.parentElement){
        const box=floating.getBoundingClientRect();
        if(getComputedStyle(floating).position==='fixed'){
          if(box.width>0&&box.width<340&&box.height>0&&box.height<160) compact(button,floating,label);
          break;
        }
      }
    });
    root.querySelectorAll('*').forEach(node=>{if(node.shadowRoot)inspect(node.shadowRoot);});
  };
  function schedule(){clearTimeout(timer);timer=setTimeout(()=>inspect(document),120);}
  const restore=()=>{
    if(!mobile.matches){
      saved.forEach((data,node)=>{node.querySelectorAll('[data-bane-wishlist-icon]').forEach(icon=>icon.remove());delete node.dataset.baneCompactWishlist;if(data.style===null)node.removeAttribute('style');else node.setAttribute('style',data.style);if(data.label===null)node.removeAttribute('aria-label');else node.setAttribute('aria-label',data.label);});
      saved.clear();
    }
    schedule();
  };
  mobile.addEventListener('change',restore);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bane-preorder-localization"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('bane-preorder-language');
  if (!config || window.banePreorderLocalization) return;
  window.banePreorderLocalization = true;
  const label = config.dataset.label;
  const message = label + ' · ' + config.dataset.message;
  const original = /^Vorbestellung\s*[-–—·]\s*Voraussichtlicher Versand\s*:?\s*7\s*[-–—]\s*10\s*Tage\s*$/i;
  const badgeText = /^(Vorbestellung|Made to Order|Pre-order|Précommande)$/i;
  const update = () => {
    document.querySelectorAll('.timesact-preOrder-message').forEach(element => {
      const text = element.textContent.trim();
      if (original.test(text) || text === message) {
        element.classList.add('bane-preorder-message');
        if (text !== message) element.textContent = message;
      } else {
        element.classList.remove('bane-preorder-message');
      }
    });
    document.querySelectorAll('.timesact-badge-preOrder span').forEach(element => {
      if (badgeText.test(element.textContent.trim())) {
        element.classList.add('bane-preorder-badge');
        if (element.textContent !== label) element.textContent = label;
      }
    });
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bane-shipping-notice"] && !Shopify.designMode) return;
  try {
    function updateBaneShippingNotice() {
    document.querySelectorAll('[data-bane-shipping-end]').forEach((notice) => {
      if (Date.now() >= Date.parse(notice.dataset.baneShippingEnd)) {
        notice.textContent = notice.dataset.baneShippingRegular;
      }
    });
  }
  updateBaneShippingNotice();
  document.addEventListener('shopify:section:load', updateBaneShippingNotice);
  document.addEventListener('visibilitychange', updateBaneShippingNotice);
  setInterval(updateBaneShippingNotice, 1000);
  } catch(e) { console.error(e); }
})();

})();
